import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { EditPartnerForm } from '../EditPartnerForm'
import NavigateBackButton from '@/common/components/NavigateBackButton'
export default function EditPartnerListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`แก้ไขรายการพาร์ทเนอร์`}
					description="แก้ไขรายการพาร์ทเนอร์"
				/>
				<NavigateBackButton />
			</div>
			<Separator />
			<EditPartnerForm />
		</div>
	)
}
